import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledBudgetProjects, StyledBudgetProjectsContent} from './style'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Button} from '@/components/ui/button/Button'
import {AlertCircleIcon, PlusIcon} from '@/components/ui/icon/Icon'
import {useGetProjectBudgets} from '@/features/budget/queries/useGetProjectBudgets'
import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {BudgetCard} from '@/features/budget/components/budget-card/BudgetCard'
import {useState} from 'react'
import {Spinner} from '@/components/ui/spinner/Spinner'

export const BudgetProjects = () => {
    const {t} = useTranslation()
    const projectBudgetsQuery = useGetProjectBudgets()
    const [isCreateMode, setIsCreateMode] = useState(false)

    return (
        <StyledBudgetProjects>
            <Flexbox align="center" justify="space-between">
                <Text size="textXl" weight="500">
                    {t('budget:projects_title')}
                </Text>
                <Button
                    variant="primaryNeutral"
                    onClick={() => setIsCreateMode(true)}
                    disabled={isCreateMode || projectBudgetsQuery.isPending}
                >
                    <PlusIcon />
                    {t('budget:budget')}
                </Button>
            </Flexbox>
            {projectBudgetsQuery.isPending ? (
                <Flexbox align="center" direction="column" gap={4}>
                    <Spinner size={32} />
                </Flexbox>
            ) : projectBudgetsQuery.isError ? (
                <ErrorBox icon={<AlertCircleIcon />} title={t('errors:default')} />
            ) : !isCreateMode && projectBudgetsQuery.data.length == 0 ? (
                <Flexbox align="center" direction="column" gap={4}>
                    <Flexbox direction="column" align="center" gap={1}>
                        <Text size="textSm" weight="500" palette="neutral" shade="600">
                            {t('budget:no_projects_found')}
                        </Text>
                        <Text size="textSm" weight="500" palette="neutral" shade="500">
                            {t('budget:no_projects_found_description')}
                        </Text>
                    </Flexbox>
                    <Button size="sm" variant="secondary" onClick={() => setIsCreateMode(true)}>
                        <PlusIcon />
                        {t('budget:add_budget')}
                    </Button>
                </Flexbox>
            ) : (
                <StyledBudgetProjectsContent>
                    {isCreateMode && (
                        <BudgetCard
                            setIsCreateMode={setIsCreateMode}
                            unallowedYears={projectBudgetsQuery.data.map(projectBudget => projectBudget.year)}
                        />
                    )}
                    {projectBudgetsQuery.data.map(projectBudget => (
                        <BudgetCard
                            key={projectBudget.id}
                            projectBudget={projectBudget}
                            unallowedYears={projectBudgetsQuery.data.map(projectBudget => projectBudget.year)}
                        />
                    ))}
                </StyledBudgetProjectsContent>
            )}
        </StyledBudgetProjects>
    )
}
